import { MenuContext, MenuSection as AriaMenuSection, MenuSectionProps } from 'react-aria-components';

import styles from './MenuSection.module.css';
import { useContext } from 'react';

export type Props<T extends object> = Pick<
  MenuSectionProps<T>,
  'selectionMode' | 'children' | 'selectedKeys' | 'onSelectionChange' | 'shouldCloseOnSelect'
>;

export function MenuSection<T extends object>({ children, selectionMode, shouldCloseOnSelect, ...rest }: Props<T>) {
  const context = useContext(MenuContext);

  if (selectionMode && context && 'selectionMode' in context && typeof context.selectionMode === 'string') {
    throw Error("It's forbidden to have selectionMode set both on MenuButton and MenuSection components");
  }

  return (
    <AriaMenuSection
      {...rest}
      selectionMode={selectionMode}
      shouldCloseOnSelect={shouldCloseOnSelect === undefined ? !selectionMode : shouldCloseOnSelect}
      className={styles.root}
    >
      {children}
    </AriaMenuSection>
  );
}
